"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardGroupe_1 = require("./DashboardGroupe");
var DashboardPhaseGroupes = /** @class */function () {
    function DashboardPhaseGroupes(data) {
        this.groupes = [];
        if (data != null) {
            this.phaseLibelle = data.phaseLibelle;
            for (var _i = 0, _a = data.groupes; _i < _a.length; _i++) {
                var grp = _a[_i];
                this.groupes.push(new DashboardGroupe_1.DashboardGroupe(grp));
            }
        }
    }
    return DashboardPhaseGroupes;
}();
exports.DashboardPhaseGroupes = DashboardPhaseGroupes;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Dashboard/Models/DashboardPhaseGroupes.ts
// module id = 178
// module chunks = 0